import BaylanCardPlugin, {ThreeDSResult} from '../plugins/BaylanCardPlugin';

export interface ThreeDSParams {
  postUrl: string;
  postData: Record<string, string>; // hook içinde URLSearchParams'a çevrilecek
}

export function useBaylanCard() {

    const hasNfc = async (): Promise<boolean> => {
        const result = await BaylanCardPlugin.hasNfc();
        return result.hasNfc;
    };

    const readCard = async () => {
        return await BaylanCardPlugin.readCard();
    };

    const loadCredit = async (amount: number) => {
        return await BaylanCardPlugin.loadCredit({amount});
    };

  const startThreeDS = async (params: ThreeDSParams): Promise<ThreeDSResult> => {
    const postDataEncoded = new URLSearchParams(params.postData).toString();

    const result = await BaylanCardPlugin.startThreeDS({
      postUrl: params.postUrl,
      postData: postDataEncoded,
    });

    return result as ThreeDSResult;
  };

    return { hasNfc, readCard, loadCredit, startThreeDS };
}
